module.exports = __webpack_public_path__ + "img/5-min.58790033.jpg";